module.exports = __webpack_public_path__ + "img/poison_desc.9d579bc3.jpg";